export enum AnswerModeEnum {
  ANSWERED = 'answered',
  SKIPPED = 'skipped',
  TIMEOUT = 'timeout',
}

export enum AnswerHintUsedEnum {
  STRONG = 'strong',
  VAGUE = 'vague',
}

export interface Score {
  correct_answer: string | string[] | string[][] | number | boolean;
  rubric_type: 'binary' | 'partial_credit';
  /** binary: 0 or 1 — partial_credit: 0..1 (fraction of marks earned) */
  value: number;
}

export interface SubmissionDetails {
  submission_details: {
    correct_answer?: Score['correct_answer'];
    score?: Pick<Score, 'rubric_type' | 'value'>;
    session_accuracy?: number;
    time_taken_seconds?: number;
    answer_mode?: AnswerModeEnum;
    hint_used?: AnswerHintUsedEnum;
  };
}

export interface IEntityUpdate {
  entity_type: string;
  entity_id: string;
  entity_name: string;
  before: number;
  after: number;
  delta: number;
}

export interface IConceptUpiScoreUpdate {
  concept_id: string;
  concept_name: string;
  before: number;
  after: number;
  delta: number;
}

/** Shared by practice (`ISubmitAnswerResponse`) and challenge (`IChallengeAnswerResponse`). */
export interface AnswerKnowledgeUpdates {
  lo_updates: IEntityUpdate[];
  concept_updates: IEntityUpdate[];
  concept_upi_score_updates: IConceptUpiScoreUpdate[];
  learner_next_action?: string | null;
}
